import React from 'react';
import { motion } from 'framer-motion';
import { 
  CameraIcon, 
  UserIcon, 
  AcademicCapIcon,
  BuildingOfficeIcon 
} from '@heroicons/react/24/outline';

const UseCaseSelection = ({ formData, updateFormData, onNext }) => {
  const useCases = [
    {
      id: 'business',
      title: 'For business',
      description: 'Manage client projects, team workflows, invoicing',
      icon: BuildingOfficeIcon,
      gradient: 'from-[#FFB27D] to-[#FF9D5C]'
    },
    {
      id: 'personal',
      title: 'For personal use',
      description: 'Organize portfolios, track personal projects, stay organized',
      icon: UserIcon,
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      id: 'education',
      title: 'For education',
      description: 'Manage photography courses, student projects, assignments',
      icon: AcademicCapIcon,
      gradient: 'from-blue-500 to-blue-600'
    }
  ];

  const handleSelection = (useCase) => {
    updateFormData({ useCase: useCase.id });
    onNext();
  };

  return (
    <div className="px-8 py-12 max-w-3xl mx-auto text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-12"
      >
        <h2 className="text-4xl font-bold text-white mb-6">
          How do you want to use Klorah?
        </h2>
        <p className="text-xl text-white/70">
          This helps customize your experience
        </p>
      </motion.div>

      <div className="space-y-4">
        {useCases.map((useCase, index) => (
          <motion.button
            key={useCase.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            onClick={() => handleSelection(useCase)}
            className="w-full p-8 rounded-2xl border border-white/10 hover:border-brand hover:shadow-lg hover:shadow-orange-500/20 transition-all duration-300 text-left group bg-white/5 hover:bg-white/10"
          >
            <div className="flex items-center gap-6">
              <div className={`p-4 rounded-xl bg-gradient-to-br ${useCase.gradient} shadow-lg`}>
                <useCase.icon className="w-8 h-8 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-white group-hover:text-brand transition-colors">
                  {useCase.title}
                </h3>
                <p className="text-base text-white/70 mt-2">
                  {useCase.description}
                </p>
              </div>
            </div>
          </motion.button>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="mt-12 text-base text-white/50"
      >
        You can change this later in your settings
      </motion.div>
    </div>
  );
};

export default UseCaseSelection;